module.exports = __webpack_public_path__ + "static/media/logoSm.90d6de5c.svg";